<template>
    <section>
        <div class="grid fixed xs-grid-cols-1 geolanding-markettrends">
            <h2 class="f3 text-bold p-t-3"><a :href='`${glb.appUrl}${glb.geo.marketTrendsPath}`' class="link">{{ getGeoTitle }} {{ molang('search.seo.realEstateSnapshot')  }}</a></h2>
            <div class="marketSnapShot">
                <div v-if="getTrendsData && getTrendsData.length && marketTrendsSummary?.marketSnapShot">
                  <mvtShifter ref="shifter">
                    <div
                        v-for="(item, i) in marketTrendsSummary.marketSnapShot"
                        :key="i"
                        class="market-info-card"
                        :class="{active: item.id == selectedMetricId}" @click="updateMetric(item)"
                    >
                      <div v-if="item.id==='mediandom'">Days on Movoto</div>
                      <div v-else-if="item.id==='mediansize'">Home Size</div>
                      <div v-else>{{item.metric_title.replace('Median', '')|| '&nbsp;'}}</div>
                      <div class="f3 infobox">
                        <b v-if="item.id==='mediansize'">{{item.value}} Sqft</b>
                        <b v-else-if="item.id==='medianpricepersqft'">{{item.value.replace('/Sqft','')}}</b>
                        <b v-else>{{item.value}}</b>
                      </div>
                    </div>
                  </mvtShifter>
                    <marketTrendsTabs ref="tabs" @updateMetric="updateMetric" v-if="selectedMetricId">
                        <marketTrendsTab
                            ref="items"
                            :hasOneMonthData="false"
                            :filterType="selectedMarketTrend"
                            :data="{metric:selectedMetric}"
                            :widgetOptions='{data: { currentId: getGeo.geoId, widgetType: getGeo.geoType }, disableWidgetView: true }'
                            @updateMarketTrend="updateMarketTrend"
                        >
                        </marketTrendsTab>
                    </marketTrendsTabs>
                </div>
                <div class="markettrends-schoolcard-noresult" v-else><i class="icon-search f1"></i> No Results</div>
            </div>
        </div>
    </section>
</template>

<script src='./geolanding-markettrends.js'>
</script>
<style lang="scss">
@use './geolanding-markettrends.scss' as *;
</style>
